import { BlockNoteEditor } from '@blocknote/core';
import { BlockSchema } from '../schema';

export default function scheduleEditorLayoutSyncFromDom(
  editor: BlockNoteEditor<BlockSchema>,
  syncFromDom: () => void,
) {
  let cancelled = false;

  const runSync = () => {
    if (cancelled) {
      return;
    }
    syncFromDom();
  };

  const syncWhenMounted = () => {
    runSync();
    requestAnimationFrame(() => {
      runSync();
      requestAnimationFrame(runSync);
    });
  };

  editor.onMount(syncWhenMounted);
  if (editor.domElement) {
    syncWhenMounted();
  }

  return () => {
    cancelled = true;
  };
}
